global.axios = require('axios');
global.$ = global.jQuery = require('jquery');

require('./sample');
require('./jquery.min');
require('./scripts.min');
require('./shared');
